import Radio from "backbone.radio";
import { _ } from "extensions/underscore";

import { TabController } from "common/controllers/tabController";
import { pazienHistory } from "common/components/pazienHistory";

import { AllCredentialsView } from "./all_credentials";
import { CredentialsModel } from "./credentialsModel";
import { CredentialsView } from "./credentialsView";

import "./endpoints.scss";

export const CredentialsController = TabController.extend({
    masterTabOptions: {
        name: "All credentials",
        view: AllCredentialsView,
        fragment: "administrator/credentials"
    },
    
    applicationViewOptions: {
        id: "credentials",
        name: "Credentials",
        hideDatePicker: true
    },
    
    channelName: "credentials",
    
    radioEvents: {
        "credential:show": function(id) {
            pazienHistory.navigateWithParams(`administrator/credentials/${id}`);
            this.showCredential(id);
        },
        "credential:create": function(id) {
            pazienHistory.navigateWithParams("administrator/credentials/new");
            this.createCredential();
        }
    },
    
    radioRequests: {
        credentials() {
            const parentChannel = this.getParentChannel();
            const parentView = parentChannel.request("get:app:view");
            let credentialsCollection;
            
            try {
                credentialsCollection = parentView.getChildView("master").collection;
            } catch {
                credentialsCollection = false;
            }
            
            return credentialsCollection;
        }
    },
    
    getParentChannel() {
        return Radio.channel("main");
    },
    
    allCredentials() {
        return this._makeTabbedView({ defaultTab: null }, ...arguments);
    },
    
    createCredential(options) {
        return this.showCredential(options, false);
    },
    
    showCredential(options, credentialsId) {
        const parentChannel = this.getParentChannel();
        const getCredentialModelFromAllTab = function() {
            const id = _.isUndefined(credentialsId) ? options : credentialsId;
            
            // Check if all reports tab has this model and then reuse it
            const parentView = parentChannel.request("get:app:view");
            let credentials;
            
            try {
                credentials = parentView.getChildView("master").collection;
            } catch {
                credentials = false;
            }
            
            if (credentials && credentials.length && id && credentials.get(id)) {
                return credentials.get(id);
            }
            let params = {};
            if (id) {
                params = { _id: id };
            }
                
            return new CredentialsModel(params);
        };
        
        const _model = getCredentialModelFromAllTab();
        return this._makeTabbedView({
            tab: {
                name: _model.getTitle(),
                newTab: true,
                view: CredentialsView,
                viewOptions: {
                    model: _model
                }
            }
        }, ...arguments);
    }
});
